var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-alarm-2--android-phone-mobile-device-smartphone-iphone-alert-bell-alarm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.875 5.5C12.2557 5.5 13.375 4.38071 13.375 3C13.375 1.61929 12.2557 0.5 10.875 0.5C9.49429 0.5 8.375 1.61929 8.375 3C8.375 4.38071 9.49429 5.5 10.875 5.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0576 8V9.53357C10.0576 9.92469 10.213 10.2998 10.4896 10.5764C10.7661 10.8529 11.2339 11.0083 11.625 11.0083H0.625C1.01612 11.0083 1.48388 10.8529 1.76045 10.5764C2.03701 10.2998 2.19239 9.92469 2.19239 9.53357L2.19238 5.93262C2.19238 4.88963 2.60671 3.88935 3.34422 3.15184C4.08173 2.41433 5.08201 2 6.125 2",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.125 13.5H7.125",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2b0b8abde5b61acbf85aaafedfa007d3.svg";
export { ForwardRef as ReactComponent };